export default __webpack_public_path__ + "static/media/pexels-cottonbro-7232039-min-min.7f83b560.jpg";